<template>
    <div>
        <MulReportHeader :dataFrom="table.params" @search="searchData" :isRange="true"></MulReportHeader>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 12px; margin-bottom: 20px" :max-height="760" ref="tableRef"></Table>
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
//盘口汇总数据
export default {
    name: 'HandicapSummaryData',
    components: { MulReportHeader },
    data() {
        return {
            loading: false,
            TransTopReqTimer: null,
            table: {
                params: {
                    platids: [],
                    app_ids: [],
                    dataTime: [this.getCurrentZeroDay(), this.getCurrentZeroDay()]
                },
                data: [],
                columns: []
            }
        }
    },
    methods: {
        //查询数据
        searchData(emitProps) {
            let allList = this.getAllHttpAppid(this.table.params)
            let httpList = []
            let all = [{ key: 'key', title: '统计项', width: 90, align: 'center' }]
            let loadingArr = [...allList]
            let stime = this.getSecond(this.table.params.dataTime[0])
            let etime = this.getSecond(this.table.params.dataTime[1], false)
            let columnsData = [
                { key: '营收比', field: 'new_win_rate' },
                { key: '人数出入占比', field: 'put_pay_rate' },
                { key: '转入赢家数占比', field: 'pay_winner_rate' },
                { key: '实钱赢家数占比', field: 'money_win_rate' },
                { key: '新增转入次日复充率', field: 'new_ci_ri_pay_rate' },
                { key: '平台转入用户次日复充率', field: 'ci_ri_pay_rate' },
                { key: '游戏盈利率', field: 'game_win_lose_rate' },
                { key: '转入金额', field: 'pay_sum' },
                { key: '营收金额', field: 'new_win_sum' },
                { key: '转入人数', field: 'pay_user_num' },
                { key: '提款人数', field: 'put_user_num' },
                { key: 'VIP转入人数', field: 'vip_pay_num' },
                { key: '银行卡转入人数', field: 'bank_pay_num' },
                { key: '线下转入金额占比大盘', field: 'offline_pay_rate' },
                { key: '线上转入成功率', field: 'online_pay_num_rate' },
                { key: '新增转化率', field: 'zhuan_rate' },
                { key: '新增用户数', field: 'new_user_num' },
                { key: '新增转入用户数', field: 'new_user_pay_num' },
                { key: '新增转入金额', field: 'new_user_pay_sum' },
                { key: '老用户转入用户数', field: 'old_user_pay_num' },
                { key: '老用户转入金额', field: 'old_user_pay_sum' },
                { key: '人均转入金额', field: 'pay_ave' },
                { key: '投注金额', field: 'bet_sum' },
                { key: '游戏盈亏', field: 'game_loss_sum' },
                { key: '游戏税收', field: 'percent_sum' },
                { key: '投注转入比', field: 'bet_pay_rate' },
                { key: '盈亏税收比', field: 'percent_loss_rate' },
                { key: '活跃用户数', field: 'active_user_num' },
                { key: '投注用户数', field: 'bet_user_num' },
                { key: '转入投注用户数', field: 'pay_bet_user_num' },
                { key: '历史代理人数', field: 'agent_num' }
            ]
            let otherData = {
                online_pay_all_num: 0,
                online_pay_success_num: 0,
                pay_winner: 0,
                pay_loser: 0,
                money_win_user: 0,
                money_lose_user: 0,
                down_pay_sum: 0,
                ci_ri_pay_num: 0,
                old_user_num: 0,
                new_ci_ri_pay_num: 0,
                new_new_num: 0
            }
            for (let i = 0, len = allList.length; i < len; i++) {
                let app_id = allList[i]
                let app_name = ''
                let platid = 0
                let item = emitProps.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                }
                let el = { platid, app_id, app_name }
                all.push({ key: `${app_id}`, title: app_name, width: 120, resizable: true, align: 'center', ...this.getRenderFunc() })
                let param = this.getTransTopParams('GetNewPlatfromData', { platid, app_id, stime, etime, general: -1, pack_no: -1, page: 1, limit: 10000, sort: 0 }, el)
                httpList.push(param)
            }
            all.push({ key: '-10', title: '合计', width: 120, resizable: true, align: 'center', ...this.getRenderFunc() })
            this.table.data = []
            this.table.columns = all
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, loadingArr, columnsData, otherData)
            }
        },
        async toHttp(httpList, loadingArr, columnsData, otherData) {
            if (httpList.length > 0) {
                let param = httpList.shift()
                let app_id = param.app_id
                this.openTimer()
                TransTopReq(param).then((res) => {
                    let data = res._param
                    let fromChildrenData = { active_user_num: 0, agent_num: 0, new_user_pay_num: 0, new_user_pay_sum: 0 }
                    data.data.forEach((item, index) => {
                        fromChildrenData.active_user_num += item.active_user_num || 0
                        fromChildrenData.agent_num += item.agent_num || 0
                        fromChildrenData.new_user_pay_num += item.new_user_pay_num || 0
                        fromChildrenData.new_user_pay_sum += item.new_user_pay_sum || 0
                    })
                    let len = data.data.length

                    data.new_user_pay_num = this.calcRate(fromChildrenData.new_user_pay_num, len) //日均新增转入用户
                    data.new_user_pay_sum = this.calcRate(fromChildrenData.new_user_pay_sum, len) //日均新增转入金额
                    data.active_user_num = this.calcRate(fromChildrenData.active_user_num, len) //日均活跃用户人数
                    data.agent_num = this.calcRate(fromChildrenData.agent_num, len) //日均历史代理

                    data.pay_sum = this.calcRate(data.pay_sum, len) //日均转入金额
                    data.pay_user_num = this.calcRate(data.pay_user_num, len) //日均转入人数
                    data.put_user_num = this.calcRate(data.put_user_num, len) //日均提款人数
                    data.new_win_sum = this.calcRate(data.new_win_sum, len) //日均营收
                    data.new_user_num = this.calcRate(data.new_user_num, len) //日均新增人数
                    data.bet_sum = this.calcRate(data.bet_sum, len) //日均投注金额
                    data.game_loss_sum = this.calcRate(data.game_loss_sum, len) //日均盈亏金额
                    data.percent_sum = this.calcRate(data.percent_sum, len) //日均。。
                    data.bet_user_num = this.calcRate(data.bet_user_num, len) //日均投注人数
                    data.pay_bet_user_num = this.calcRate(data.pay_bet_user_num, len) //日均充投人数
                    data.old_user_pay_sum = data.pay_sum - data.new_user_pay_sum //老用户转入金额
                    data.old_user_pay_num = data.pay_user_num - data.new_user_pay_num //老用户转入人数
                    data.zhuan_rate = this.calcRate(data.new_user_pay_num, data.new_user_num) //新增转化率
                    data.percent_loss_rate = this.calcRate(data.game_loss_sum, data.percent_sum) //盈亏税收比
                    data.game_win_lose_rate = this.calcRate(data.game_loss_sum, data.bet_sum)
                    let params1 = this.copyData(param)
                    params1.param._func = 'GetUserPayActiveData'
                    TransTopReq(params1).then((res1) => {
                        //获取vip、银行卡、线下转入金额 data1
                        let len1 = res1._param.data.length - 1
                        let data1 = {
                            bank_pay_num: this.calcRate(res1._param.total_bank_pay_num, len1),
                            vip_pay_num: this.calcRate(res1._param.total_vip_pay_num, len1),
                            down_pay_sum: this.calcRate(res1._param.total_down_sum, len1)
                        }
                        let params2 = this.copyData(param)
                        params2.param._func = 'GetNewPlatformRepeatPayInfo'
                        params2.param._param.stime = params2.param._param.stime - 24 * 60 * 60
                        params2.param._param.etime = params2.param._param.etime - 24 * 60 * 60
                        TransTopReq(params2).then((res2) => {
                            //获取转入次日复冲率 data2
                            let from2 = res2._param
                            let data2 = { ci_ri_pay_num: 0, old_user_num: 0 }
                            from2.data.forEach((item) => {
                                data2.ci_ri_pay_num += item.ci_ri_pay_num
                                data2.old_user_num += item.user_pay_num
                            })
                            data2.ci_ri_pay_rate = this.calcRate(data2.ci_ri_pay_num, data2.old_user_num)

                            let params3 = this.copyData(params2)
                            params3.param._func = 'GetNewPlatfromNewPayInfo'
                            TransTopReq(params3).then((res3) => {
                                //获取新增转入次日复充率 data3
                                let from3 = res3._param
                                let data3 = { new_ci_ri_pay_num: 0, new_new_num: 0 }
                                from3.data.forEach((item) => {
                                    data3.new_ci_ri_pay_num += item.ci_ri_pay_num
                                    data3.new_new_num += item.new_num
                                })
                                data3.new_ci_ri_pay_rate = this.calcRate(data3.new_ci_ri_pay_num, data3.new_new_num)

                                let result = Object.assign(data, data1, data2, data3)
                                result.offline_pay_rate = this.calcRate(result.pay_sum - result.down_pay_sum, result.pay_sum)

                                columnsData.forEach((el) => {
                                    el[`${app_id}`] = result[el.field]
                                    el['-10'] = el['-10'] || 0
                                    el['-10'] += result[el.field]
                                })
                                for (let key in otherData) {
                                    otherData[key] += result[key]
                                }
                                this.reCalcAll(columnsData, otherData)
                                this.table.data = this.copyData(columnsData)
                                this.toHttp(httpList, loadingArr, columnsData, otherData)
                            })
                        })
                    })
                })
            }
        },
        getRenderFunc() {
            return {
                render: (h, params) => {
                    let key = params.column.key //app_id
                    let field = params.row.field //显示的数据字段
                    let value = params.row[key] //当前的数据值
                    if (field.includes('_rate') || key.includes('比')) {
                        if (field == 'new_win_rate' && value == -1) return h('span', '-')
                        if (field == 'game_win_lose_rate') return h('span', Math.floor(value * 10000) / 100 + '%')
                        if (field == 'bet_pay_rate') return h('span', this.getCustomFixed(value))
                        return h('span', (value * 100 || 0).toFixed(2) + '%')
                    } else if (field.includes('_sum') || field.includes('_point') || field == 'pay_ave') {
                        return h('span', this.getCustomFixed(value / 10000))
                    } else {
                        return h('span', this.getCustomFixed(value))
                    }
                }
            }
        },
        //合计重新计算
        reCalcAll(data, other) {
            let put_user_num = data[10][-10] //提款人数
            let pay_user_num = data[9][-10] //转入人数
            let new_win_sum = data[8][-10] //营收金额
            let pay_sum = data[7][-10] //转入金额
            let bet_sum = data[22][-10] //投注金额

            data[1][-10] = this.calcRate(put_user_num, pay_user_num) //人数转入转出比
            data[0][-10] = this.calcRate(new_win_sum, pay_sum) //营收比重新计算
            data[21][-10] = this.calcRate(pay_sum, pay_user_num) //人均转入金额
            data[25][-10] = this.calcRate(bet_sum, pay_sum) //投注转入比

            let pay_winner = other.pay_winner //转入赢家人数
            let pay_loser = other.pay_loser //转入输家人数
            data[2][-10] = this.calcRate(pay_winner, pay_winner + pay_loser) //转入赢家数占比

            let money_win_user = other.money_win_user //实钱赢家人数
            let money_lose_user = other.money_lose_user //实钱输家人数
            data[3][-10] = this.calcRate(money_win_user, money_win_user + money_lose_user) //实钱赢家数占比

            let new_user_pay_num = data[17][-10] //新增且转入用户
            let new_user_num = data[16][-10] //新增用户
            data[15][-10] = this.calcRate(new_user_pay_num, new_user_num) //新增转化率

            let game_loss_sum = data[23][-10] //游戏盈亏
            let percent_sum = data[24][-10] //税收金额
            data[26][-10] = this.calcRate(game_loss_sum, percent_sum) //盈亏税收比

            let down_pay_sum = other.down_pay_sum
            data[13][-10] = this.calcRate(pay_sum - down_pay_sum, pay_sum)

            data[14][-10] = this.calcRate(other.online_pay_success_num, other.online_pay_all_num) //在线
            data[4][-10] = this.calcRate(other.new_ci_ri_pay_num, other.new_new_num) //合计新增次日转入复充率
            data[5][-10] = this.calcRate(other.ci_ri_pay_num, other.old_user_num) //合计次日转入复充率
        },
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 6000)
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param, item) {
            return {
                mod: 'root',
                platid: item.platid,
                app_id: item.app_id,
                app_name: item.app_name,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        }
    }
}
</script>

<style scoped lang="less"></style>
